<template>
  <TksCalculatingDetail />
</template>

<script>
import TksCalculatingDetail from "@/components/Calculatings/TksCalculating/Detail.vue";
export default {
  components: { TksCalculatingDetail },
};
</script>

<style></style>
